<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    v-if="this.$store.getters['auth/userStatus'] === true"
    placement="bottom-end"
    add-menu-classes="pt-0 pb-0 dropdown-menu-noti mt-4 bg-transparent border-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <img
          src="@/assets/icons/Notibell.svg"
          class="mt-2 mr-3 ml-2 noti-bell"
        />
      </CHeaderNavLink>
    </template>
    <CDropdownHeader class="header-noti">
      <h1>NOTIFICATIONS</h1>
      <p>
        You have
        <strong v-if="this.readAll == false"
          >{{ this.notiMessage.length }} Notifications</strong
        >
        <strong v-else>0 Notifications</strong>
      </p>
      <a
        href="#"
        @click="onRead(item.notify._id)"
        v-if="this.readAll == false"
        class="read"
        >Mark all as read</a
      >
    </CDropdownHeader>
    <div v-if="!readAll">
      <CDropdownItem
        class="dropdown-item-notimessage"
        v-for="(item, index) in notiMessage"
        :key="index"
        @click="onNotice"
      >
        <CBadge v-if="!item.read">
          <CCol
            v-if="item.notify.notifytype != undefined"
            href="#"
            @click="onRead(item.notify._id)"
            class="flex-column align-items-start hover unread-text"
          >
            <h1
              v-if="item.notify.notifytype == 0"
              class="dropdown-item-notimessage"
            >
              COURSE
            </h1>
            <h1
              v-if="item.notify.notifytype == 1"
              class="dropdown-item-notimessage"
            >
              PAYMENT
            </h1>
            <h1
              v-if="item.notify.notifytype == 2"
              class="dropdown-item-notimessage"
            >
              STATUS
            </h1>
            <p class="message" style="float:left">
              {{ item.notify.messages[0].val }}
            </p>
            <br />
            <p class="time" style="float:right">
              {{ onDateFormat(item.notify.date) }}
            </p>
          </CCol>
        </CBadge>
      </CDropdownItem>
    </div>
    <div v-else class="no-message" style="text-align: center;">
      <h1 class="mb-0">No message</h1>
      <img src="@/assets/icons/warning.svg" class="mt-2 mb-3 icon-warning" />
    </div>
    <CDropdownHeader v-on:click="accountManagement('no')" class="footer-noti">
      <CButton class="seeall pt-0 pl-0 pb-0 pr-0">
        <p class="pt-2 mb-0">SEE ALL</p>
      </CButton>
    </CDropdownHeader>
  </CDropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TheHeaderDropdownNotimessage",
  data() {
    return {
      itemsCount: 42,
      notiMessage: [],
      readAll: false,
    };
  },
  created() {},
  mounted() {
    if (this.$store.getters["auth/userStatus"]) {
      this.$store.dispatch("profile/getUserNoticeData");
    }
  },
  computed: {
    ...mapGetters({
      getNoticeMessage: "profile/getUserNotice",
      getMarkingread: "updateProfile/getMarkging",
    }),
  },
  watch: {
    getNoticeMessage: function(val) {
      var countRead = 0;
      this.notiMessage = val;
      this.notiMessage.forEach((ele) => {
        if (ele.read == true) {
          countRead++;
        }
      });
      if (countRead == this.notiMessage.length) {
        this.readAll = true;
      }
    },
    getMarkingread: function(val) {
      if (val == false) {
        /// update complete
        if (this.$store.getters["auth/userStatus"]) {
          this.$store.dispatch("profile/getUserNoticeData");
        }
      }
    },
  },
  methods: {
    accountManagement: function(signal) {
      this.$router.push({
        name: "MainProfile",
        params: {
          signal: signal,
        },
      });
    },
    onRead(id) {
      // alert("mark as read id = ", id);
      const body = {
        notifyId: id,
      };
      this.$store.dispatch("updateProfile/onMarkNotice", body);
    },
    onDateFormat(date) {
      return new Date(date)
        .toISOString()
        .replace(/T/, " ")
        .replace(/\..+/, "");
    },
    onNotice() {
      this.$router.push({
        name: "MainProfile",
        params: {
          signal: "no",
        },
      });
    },
  },
};
</script>

<style>
.dropdown-menu-noti {
  border: 0px;
  border-radius: 20px 20px 20px 20px;
  -webkit-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
  box-shadow: 10px 15px 20px 1px rgba(0, 0, 0, 0.5);
}
</style>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap");
.badge {
  width: 470px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-noti {
  width: 500px;
  backdrop-filter: blur(50px) !important;
  -webkit-backdrop-filter: blur(50px) !important;
  background-color: rgba(255, 255, 253, 0.5);
  border: 0px;
  opacity: 1;
  border-radius: 20px 20px 0px 0px;
}
.footer-noti {
  width: 500px;
  backdrop-filter: blur(50px) !important;
  -webkit-backdrop-filter: blur(50px) !important;
  background-color: rgba(255, 255, 253, 0.5);
  border: 0px;
  opacity: 1;
  border-radius: 0px 0px 20px 20px;
}

.icon-warning {
  width: 100px;
}
.footer-noti p {
  font-family: "Roboto";
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  border: 0px;
}
.header-noti h1 {
  font-family: "Roboto";
  color: #000000;
  font-weight: bold;
  font-size: 24px;
}

.no-message h1 {
  font-family: "Roboto";
  color: #000000;
  font-weight: 500;
  font-size: 24px;
  text-align: center;
}

.seeall {
  width: 452px;
}

.no-message {
  background-color: white;
}

.header-noti p {
  font-family: "Roboto";
  color: #000000;
  font-size: 14px;
  margin-top: -0.5em;
}

.dropdown-header-notimessage p {
  font-family: "Roboto";
  color: #000000;
  font-weight: 300;
  font-size: 14px;
}

.read {
  float: right;
  font-family: "Roboto";
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  margin-top: -4em;
}

.dropdownfooter-notimessage:hover {
  color: #000000;
}

.dropdown-item-notimessage {
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item-notimessage h1 {
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  font-size: 20px;
  text-align: left;
}

.dropdown-menu.show {
  padding-bottom: 0px;
  border: 0px;
}
.dropdown-menu {
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item-notimessage p {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-size: 16px;
}

.dropdown-item {
  width: 500px;
  padding-top: 5px;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  border: 0px;
}

.dropdown-item:hover {
  background-color: #ffa800;
  filter: invert(100%);
  color: black !important;
  border: 0px;
}

.dropdownfooter-notimessage {
  font-family: "Roboto";
  color: #000000;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  border: 0px;
}

.dropdownfooter-notimessage p {
  margin-top: 0.5em;
  border: 0px;
}

.badge {
  width: 480px;
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.content {
  float: left;
}
.time p {
  float: right;
  margin-top: 1em;
}

.right {
  float: right;
}
.noti-bell {
  width: 25px;
}
.dropdown-menu.show {
  display: block;
  border-radius: 20px;
}

@media only screen and (max-width: 768px) {
  .noti-bell {
    display: none;
  }
}

@media only screen and (max-width: 767px) {
  .noti-bell {
    margin-right: 1em;
  }
}

@media only screen and (max-width: 1023px) {
  .noti-bell {
    margin-right: 0.2em;
  }
}

/* body
  > div:nth-child(2)
  > div:nth-child(2)
  > header
  > ul:nth-child(4)
  > li.c-header-nav-items.dropdown.show.nav-item
  > div
  > a.dropdown-item.dropdownfooter-notimessage {
  height: 50px;
  background-color: #cccccc;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
} */
</style>
